import {
  Avatar,
  Button,
  Card,
  Dialog,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Switch,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { Box, useTheme } from '@mui/system';
import { NotesCard } from 'component/ExpandedBuyerCard/ExpendedCardDocumentation';
import {
  DownArrowIcon,
  UpDownArrowIcon,
} from 'component/TaskPageNoteandFeedback/TaskPageFeedbackAll';
import { useEffect, useState } from 'react';
import { poppins500 } from 'theme/common.style';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const ArrowDown = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.773438"
        y="0.5"
        width="23"
        height="23"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M13.1916 16.006C12.6967 16.5418 11.8501 16.5418 11.3552 16.006L7.28346 11.5982C6.54389 10.7976 7.11173 9.5 8.20165 9.5L16.3452 9.5C17.4351 9.5 18.003 10.7976 17.2634 11.5982L13.1916 16.006Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};

const MarkerPen = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.25369 10.2506L2.77907 10.3978C2.16461 10.5885 1.50993 10.9206 0.885968 11.3584L0.875874 11.3655L0.426999 10.9167L0.434199 10.9065C0.871792 10.2826 1.204 9.62787 1.39466 9.01348L1.54191 8.53893C1.57227 8.44104 1.51757 8.33705 1.41975 8.3067C1.32208 8.27642 1.21795 8.33097 1.18752 8.42886L1.04027 8.90342C0.860882 9.48158 0.546269 10.1006 0.130421 10.6934L0.033714 10.831C-0.0180907 10.9048 -0.00940716 11.0051 0.0543468 11.0688L0.723651 11.7381C0.759499 11.774 0.807074 11.7924 0.854945 11.7924C0.89198 11.7924 0.929237 11.7813 0.961523 11.7587L1.09912 11.6621C1.69191 11.2462 2.31082 10.9316 2.88906 10.7521L3.36369 10.6049C3.46151 10.5745 3.51628 10.4705 3.48585 10.3727C3.4555 10.2748 3.35159 10.2201 3.25369 10.2506Z"
        fill="#A58BC9"
      />
      <path
        d="M9.05121 0.797548C8.9787 0.725036 8.86129 0.725036 8.78885 0.797548L2.43105 7.15535L1.71454 7.87193C1.64203 7.94437 1.64203 8.06186 1.71454 8.13429L3.6584 10.0782C3.69462 10.1144 3.74212 10.1325 3.78962 10.1325C3.83712 10.1325 3.88455 10.1144 3.92084 10.0782L4.63742 9.36157L10.9951 3.00377C11.0677 2.93134 11.0677 2.81385 10.9951 2.74141L9.05121 0.797548ZM3.78955 9.68457L2.10805 8.00307L2.56219 7.54893L4.06505 9.05171L4.24377 9.23043L3.78955 9.68457ZM4.50613 8.96799L3.00327 7.46521L2.82456 7.28649L8.91999 1.19113L10.6015 2.87263L4.50613 8.96799Z"
        fill="#A58BC9"
      />
      <path
        d="M11.2784 1.38157L10.4105 0.513583C10.2222 0.325513 9.91632 0.325587 9.72825 0.513583L9.52704 0.714716C9.45453 0.787228 9.45453 0.904642 9.52704 0.977154C9.59955 1.04967 9.71697 1.04959 9.7894 0.977154L9.99061 0.776021C10.034 0.732677 10.1045 0.732603 10.1481 0.776021L11.016 1.64401C11.037 1.66509 11.0486 1.69307 11.0486 1.72276C11.0486 1.75252 11.037 1.78042 11.016 1.8015L10.8149 2.00263C10.7424 2.07515 10.7424 2.19256 10.8149 2.26507C10.8511 2.30129 10.8986 2.3194 10.9461 2.3194C10.9936 2.3194 11.0411 2.30129 11.0773 2.26507L11.2785 2.06394C11.3696 1.9728 11.4198 1.85167 11.4198 1.72276C11.4197 1.59384 11.3696 1.47264 11.2784 1.38157Z"
        fill="#A58BC9"
      />
    </svg>
  );
};

const Delete = () => {
  return (
    <svg
      width="11"
      height="13"
      viewBox="0 0 11 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.38249 12.8727H2.05432C1.64371 12.8727 1.30072 12.5519 1.27343 12.1421L0.765625 4.5249H9.67114L9.16333 12.1422C9.13609 12.5519 8.7931 12.8727 8.38249 12.8727ZM1.32336 5.04664L1.79408 12.1074C1.80316 12.244 1.91747 12.351 2.05432 12.351H8.38244C8.51929 12.351 8.63361 12.244 8.64269 12.1075L9.1134 5.04664H1.32336Z"
        fill="#A58BC9"
      />
      <path
        d="M9.65082 4.00297H0.78125V2.69862C0.78125 2.26709 1.13233 1.91602 1.56386 1.91602H8.86821C9.29974 1.91602 9.65082 2.26709 9.65082 2.69862V4.00297ZM1.30299 3.48123H9.12908V2.69862C9.12908 2.55478 9.01205 2.43775 8.86821 2.43775H1.56386C1.42002 2.43775 1.30299 2.55478 1.30299 2.69862V3.48123Z"
        fill="#A58BC9"
      />
      <path d="M10.4348 3.48145H0V4.00318H10.4348V3.48145Z" fill="#A58BC9" />
      <path
        d="M3.91457 11.3077H3.39283C3.10468 11.3077 2.87109 11.0741 2.87109 10.786V6.61207C2.87109 6.32391 3.10468 6.09033 3.39283 6.09033H3.91457C4.20273 6.09033 4.43631 6.32391 4.43631 6.61207V10.786C4.43631 11.0741 4.20273 11.3077 3.91457 11.3077Z"
        fill="#FCFCFC"
      />
      <path
        d="M3.91372 11.5682H3.39198C2.96045 11.5682 2.60938 11.2172 2.60938 10.7856V6.61171C2.60938 6.18018 2.96045 5.8291 3.39198 5.8291H3.91372C4.34525 5.8291 4.69633 6.18018 4.69633 6.61171V10.7856C4.69633 11.2172 4.34525 11.5682 3.91372 11.5682ZM3.39198 6.35084C3.24814 6.35084 3.13111 6.46787 3.13111 6.61171V10.7856C3.13111 10.9295 3.24814 11.0465 3.39198 11.0465H3.91372C4.05757 11.0465 4.17459 10.9295 4.17459 10.7856V6.61171C4.17459 6.46787 4.05757 6.35084 3.91372 6.35084H3.39198Z"
        fill="#A58BC9"
      />
      <path
        d="M7.04348 11.3077H6.52174C6.23358 11.3077 6 11.0741 6 10.786V6.61207C6 6.32391 6.23358 6.09033 6.52174 6.09033H7.04348C7.33163 6.09033 7.56522 6.32391 7.56522 6.61207V10.786C7.56522 11.0741 7.33163 11.3077 7.04348 11.3077Z"
        fill="#FCFCFC"
      />
      <path
        d="M7.04263 11.5682H6.52089C6.08936 11.5682 5.73828 11.2172 5.73828 10.7856V6.61171C5.73828 6.18018 6.08936 5.8291 6.52089 5.8291H7.04263C7.47416 5.8291 7.82524 6.18018 7.82524 6.61171V10.7856C7.82524 11.2172 7.47416 11.5682 7.04263 11.5682ZM6.52089 6.35084C6.37705 6.35084 6.26002 6.46787 6.26002 6.61171V10.7856C6.26002 10.9295 6.37705 11.0465 6.52089 11.0465H7.04263C7.18647 11.0465 7.3035 10.9295 7.3035 10.7856V6.61171C7.3035 6.46787 7.18647 6.35084 7.04263 6.35084H6.52089Z"
        fill="#A58BC9"
      />
      <path
        d="M6.52276 2.43778H3.91406V1.65517C3.91406 1.22364 4.26514 0.872559 4.69667 0.872559H5.74015C6.17168 0.872559 6.52276 1.22364 6.52276 1.65517V2.43778ZM4.4358 1.91604H6.00102V1.65517C6.00102 1.51132 5.88399 1.3943 5.74015 1.3943H4.69667C4.55283 1.3943 4.4358 1.51132 4.4358 1.65517V1.91604Z"
        fill="#A58BC9"
      />
    </svg>
  );
};

const Location = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.0179 1.70609C4.94521 1.69565 2.43543 4.14029 2.33512 7.20029L2.33203 7.39022C2.3831 8.8901 2.89341 10.3198 3.79222 11.4978L4.00331 11.7733C4.86123 12.8641 5.88077 13.8216 7.02555 14.6108L7.30118 14.7963L7.34139 14.8279C7.73376 15.1098 8.26354 15.1098 8.65591 14.8279L8.68938 14.8004C9.59774 14.2113 10.4354 13.5191 11.1857 12.7376C12.7111 11.1229 13.6305 9.31355 13.6652 7.47604L13.6653 7.40782C13.6757 4.32734 11.2386 1.80983 8.188 1.70918L8.0179 1.70609ZM8.01437 2.72034C10.5334 2.72895 12.5786 4.74164 12.6545 7.2481L12.6567 7.4691C12.6275 9.00965 11.8209 10.597 10.4563 12.0415C9.76055 12.7662 8.98042 13.4104 8.1343 13.9583L8.07791 14.0007C8.03234 14.0403 7.96475 14.0403 7.91918 14.0007L7.86437 13.9594C6.60391 13.1364 5.49764 12.0974 4.59617 10.8898C3.87005 9.93816 3.43977 8.80029 3.35316 7.61329L3.34043 7.37527C3.34899 4.85017 5.35548 2.79868 7.85423 2.7225L8.01437 2.72034ZM7.99871 5.30519C6.80645 5.30519 5.83993 6.27469 5.83993 7.47064C5.83993 8.66658 6.80645 9.63608 7.99871 9.63608C9.19098 9.63608 10.1575 8.66658 10.1575 7.47064C10.1575 6.27469 9.19098 5.30519 7.99871 5.30519ZM7.99863 6.31953C8.63391 6.31953 9.14891 6.83612 9.14891 7.47336C9.14891 8.11061 8.63391 8.62719 7.99863 8.62719C7.36335 8.62719 6.84835 8.11061 6.84835 7.47336C6.84835 6.83612 7.36335 6.31953 7.99863 6.31953Z"
        fill="#112347"
      />
    </svg>
  );
};
const TaskDeleteIcon = () => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.655 21.0002H12.3268C11.9162 21.0002 11.5732 20.6793 11.5459 20.2696L11.0381 12.6523H19.9436L19.4358 20.2696C19.4086 20.6793 19.0656 21.0002 18.655 21.0002ZM11.5958 13.1741L12.0665 20.2349C12.0756 20.3715 12.1899 20.4784 12.3268 20.4784H18.6549C18.7918 20.4784 18.9061 20.3715 18.9151 20.2349L19.3859 13.1741H11.5958Z"
        fill="#A58BC9"
      />
      <path
        d="M19.9252 12.1309H11.0557V10.8266C11.0557 10.395 11.4067 10.0439 11.8383 10.0439H19.1426C19.5742 10.0439 19.9252 10.395 19.9252 10.8266V12.1309ZM11.5774 11.6092H19.4035V10.8266C19.4035 10.6827 19.2865 10.5657 19.1426 10.5657H11.8383C11.6944 10.5657 11.5774 10.6827 11.5774 10.8266V11.6092Z"
        fill="#A58BC9"
      />
      <path
        d="M20.7082 11.6084H10.2734V12.1301H20.7082V11.6084Z"
        fill="#A58BC9"
      />
      <path
        d="M14.1861 19.4342H13.6643C13.3762 19.4342 13.1426 19.2006 13.1426 18.9124V14.7385C13.1426 14.4504 13.3762 14.2168 13.6643 14.2168H14.1861C14.4742 14.2168 14.7078 14.4504 14.7078 14.7385V18.9124C14.7078 19.2006 14.4742 19.4342 14.1861 19.4342Z"
        fill="#FCFCFC"
      />
      <path
        d="M14.1862 19.6952H13.6644C13.2329 19.6952 12.8818 19.3441 12.8818 18.9126V14.7387C12.8818 14.3071 13.2329 13.9561 13.6644 13.9561H14.1862C14.6177 13.9561 14.9688 14.3071 14.9688 14.7387V18.9126C14.9688 19.3442 14.6177 19.6952 14.1862 19.6952ZM13.6644 14.4778C13.5206 14.4778 13.4036 14.5948 13.4036 14.7387V18.9126C13.4036 19.0564 13.5206 19.1734 13.6644 19.1734H14.1862C14.33 19.1734 14.4471 19.0564 14.4471 18.9126V14.7387C14.4471 14.5948 14.33 14.4778 14.1862 14.4778H13.6644Z"
        fill="#A58BC9"
      />
      <path
        d="M17.3169 19.4342H16.7952C16.507 19.4342 16.2734 19.2006 16.2734 18.9124V14.7385C16.2734 14.4504 16.507 14.2168 16.7952 14.2168H17.3169C17.6051 14.2168 17.8387 14.4504 17.8387 14.7385V18.9124C17.8387 19.2006 17.6051 19.4342 17.3169 19.4342Z"
        fill="#FCFCFC"
      />
      <path
        d="M17.317 19.6952H16.7953C16.3638 19.6952 16.0127 19.3441 16.0127 18.9126V14.7387C16.0127 14.3071 16.3638 13.9561 16.7953 13.9561H17.317C17.7486 13.9561 18.0997 14.3071 18.0997 14.7387V18.9126C18.0997 19.3442 17.7486 19.6952 17.317 19.6952ZM16.7953 14.4778C16.6515 14.4778 16.5344 14.5948 16.5344 14.7387V18.9126C16.5344 19.0564 16.6515 19.1734 16.7953 19.1734H17.317C17.4609 19.1734 17.5779 19.0564 17.5779 18.9126V14.7387C17.5779 14.5948 17.4609 14.4778 17.317 14.4778H16.7953Z"
        fill="#A58BC9"
      />
      <path
        d="M16.7952 10.5652H14.1865V9.78261C14.1865 9.35108 14.5376 9 14.9691 9H16.0126C16.4441 9 16.7952 9.35108 16.7952 9.78261V10.5652ZM14.7083 10.0435H16.2735V9.78261C16.2735 9.63877 16.1565 9.52174 16.0126 9.52174H14.9691C14.8253 9.52174 14.7083 9.63877 14.7083 9.78261V10.0435Z"
        fill="#A58BC9"
      />
    </svg>
  );
};
const TaskEditIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.52713 14.378L7.0525 14.5253C6.43805 14.7159 5.78336 15.0481 5.15941 15.4858L5.14931 15.4929L4.70044 15.0441L4.70764 15.034C5.14523 14.41 5.47743 13.7553 5.6681 13.1409L5.81535 12.6664C5.84571 12.5685 5.79101 12.4645 5.69319 12.4341C5.59552 12.4039 5.49139 12.4584 5.46096 12.5563L5.31371 13.0309C5.13432 13.609 4.81971 14.228 4.40386 14.8208L4.30715 14.9585C4.25535 15.0322 4.26403 15.1326 4.32778 15.1963L4.99709 15.8655C5.03294 15.9014 5.08051 15.9198 5.12838 15.9198C5.16542 15.9198 5.20267 15.9088 5.23496 15.8861L5.37256 15.7895C5.96535 15.3736 6.58426 15.059 7.1625 14.8796L7.63712 14.7323C7.73495 14.702 7.78972 14.598 7.75929 14.5002C7.72893 14.4023 7.62503 14.3476 7.52713 14.378Z"
        fill="#A58BC9"
      />
      <path
        d="M13.3246 4.92548C13.2521 4.85297 13.1347 4.85297 13.0623 4.92548L6.70449 11.2833L5.98798 11.9999C5.91547 12.0723 5.91547 12.1898 5.98798 12.2622L7.93184 14.2061C7.96806 14.2423 8.01556 14.2604 8.06306 14.2604C8.11056 14.2604 8.15799 14.2423 8.19428 14.2061L8.91086 13.4895L15.2686 7.1317C15.3411 7.05927 15.3411 6.94178 15.2686 6.86934L13.3246 4.92548ZM8.06299 13.8125L6.38148 12.131L6.83563 11.6769L8.33849 13.1796L8.5172 13.3584L8.06299 13.8125ZM8.77957 13.0959L7.27671 11.5931L7.09799 11.4144L13.1934 5.31906L14.8749 7.00056L8.77957 13.0959Z"
        fill="#A58BC9"
      />
      <path
        d="M15.5528 5.50901L14.6849 4.64102C14.4967 4.45295 14.1907 4.45303 14.0027 4.64102L13.8015 4.84216C13.7289 4.91467 13.7289 5.03208 13.8015 5.1046C13.874 5.17711 13.9914 5.17703 14.0638 5.1046L14.265 4.90346C14.3084 4.86012 14.3789 4.86004 14.4225 4.90346L15.2904 5.77145C15.3114 5.79253 15.323 5.82051 15.323 5.8502C15.323 5.87996 15.3114 5.90786 15.2904 5.92894L15.0893 6.13008C15.0168 6.20259 15.0168 6.32 15.0893 6.39251C15.1255 6.42873 15.173 6.44684 15.2205 6.44684C15.268 6.44684 15.3155 6.42873 15.3517 6.39251L15.5529 6.19138C15.644 6.10024 15.6942 5.97911 15.6942 5.8502C15.6941 5.72128 15.644 5.60008 15.5528 5.50901Z"
        fill="#A58BC9"
      />
    </svg>
  );
};
const Activities = ({
  buyerId,
  ownercardprop,
  proid,
  rowData,
  notes,
  setNotes,
  handleUpdateNote,
  setValue,
  setNoteToEdit,
  setIsNoteEdit,
  updateNoteScrollRef,
  isNoteEdit,
  handleDeleteNote,
}) => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  const highlightStyle = {
    animation: 'blink 2s ease-in-out 2',
    border: '2px solid rgb(25,118,210)',
  };

  const notesSubject = {
    color: '#666',
    fontFamily: 'poppins',
    fontSize: matchessm ? '10px' : '12px',
    fontWeight: 500,
    textTransform: 'capitalize',
  };
  const notesMidLine = {
    color: '#666',
    fontFamily: 'poppins',
    fontSize: matchessm ? '10px' : '12px',
    fontWeight: 500,
    textTransform: 'capitalize',
  };

  return (
    <Grid container sx={{ width: '100%', marginBottom: '20px' }}>
      {notes?.map((item, index) => {
        return (
          <Grid item xs={12} key={item?.noteId} sx={{ width: '100%' }}>
            <Card
              sx={{
                margin: '15px 0px',
                padding: '10px',
                boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
                borderRadius: '5px',
                width: '100%',
                boxSizing: 'border-box',
              }}
            >
              <Grid container>
                <Grid xs={12}>
                  <Grid
                    container
                    sx={{
                      display: 'flex',
                      flexDirection: matchessm ? 'column' : 'row',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      gap: matchessm ? '5px' : '0px',
                    }}
                  >
                    <Grid xs={12} sm={6}>
                      <Typography sx={notesSubject}>
                        Subject : {item.subject}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        display: 'flex',
                        justifyContent: matchessm ? 'center' : 'flex-end',
                      }}
                      xs={12}
                      sm={6}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: ' center',
                          gap: matchessm ? '5px' : '20px',
                          marginRight: matchessm ? '10px' : '40px',
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: matchessm ? '10px' : '14px',
                            fontWeight: 500,
                            padding: '3px 10px',
                            borderRadius: '10px',
                            background: '#345B83',
                            color: 'white',
                            fontFamily: 'poppins',
                          }}
                        >
                          {ownercardprop ? '#VendorReport' : '#BuyerReport'}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: matchessm ? '10px' : '14px',
                            fontWeight: 500,
                            padding: '3px 10px',
                            borderRadius: '10px',
                            background: '#F39800',
                            color: 'white',
                            fontFamily: 'poppins',
                          }}
                        >
                          #Private
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: matchessm ? '5px' : '10px',
                        }}
                      >
                        <Card sx={{ display: 'flex', flexDirection: 'column' }}>
                          <IconButton sx={{ padding: '0 !important' }}>
                            <KeyboardArrowUpIcon />
                          </IconButton>
                          <IconButton sx={{ padding: '0 !important' }}>
                            <KeyboardArrowDownIcon />
                          </IconButton>
                        </Card>
                        <IconButton disableRipple>
                          <ArrowDown />
                        </IconButton>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                xs={12}
                sx={{
                  display: 'flex',
                  alignItems: matchessm ? 'flex-start' : 'center',
                  gap: matchessm ? '3px' : '5px',
                  flexDirection: matchessm ? 'column' : 'row',
                  justifyContent: 'space-between',
                  marginTop: '10px',
                }}
              >
                <Typography sx={notesMidLine}>
                  Created : {item?.createdAt}
                </Typography>
                <Typography sx={notesMidLine}>
                  Added by {item?.agentName}
                </Typography>
                <Typography sx={notesMidLine}>
                  Address : {item?.propertyAddress}
                </Typography>
              </Grid>
              <Grid xs={12}>
                <Typography
                  sx={{
                    color: '#200E32',
                    fontSize: matchessm ? '10px' : '12px',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    fontFamily: 'poppins',
                  }}
                >
                  {item.notesMessage}
                </Typography>
              </Grid>
              <Grid
                xs={12}
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                }}
              >
                <IconButton
                  onClick={() => {
                    setNoteToEdit(item);
                    setIsNoteEdit(true);
                    setValue((prev) => {
                      if (prev !== 0) {
                        setTimeout(() => {
                          updateNoteScrollRef.current?.scrollIntoView({
                            behavior: 'smooth',
                            block: 'end',
                          });
                        }, 0);
                      } else {
                        updateNoteScrollRef.current?.scrollIntoView({
                          behavior: 'smooth',
                          block: 'end',
                        });
                      }
                      return 0;
                    });
                  }}
                >
                  <TaskEditIcon />
                </IconButton>
                <IconButton
                  onClick={() => {
                    handleDeleteNote(item);
                  }}
                >
                  <TaskDeleteIcon />
                </IconButton>
              </Grid>
            </Card>
          </Grid>
        );
      })}
      {notes?.length == 0 && (
        <Typography
          sx={{
            fontWeight: 400,
            fontFamily: 'poppins',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '25px',
            color: '#666666',
          }}
        >
          No notes available
        </Typography>
      )}
    </Grid>
  );
};
export default Activities;
